import React, { useState } from "react";
import Swiper from "react-id-swiper";
import "swiper/css/swiper.css";
import { SliderMenu } from "..";

const SelectedOpusSlider = (props) => {
  //   const [opusImages, setOpusImages] = useState([]);
  const opusData = props.opusData;
  console.log(opusData);
  const [params] = useState({
    // pagination: {
    //   el: ".swiper-pagination",
    //   type: "bullets",
    //   clickable: true,
    //   dynamicBullets: true,
    // },
    // navigation: {
    //   nextEl: ".swiper-button-prev.swiper-button-white",
    //   prevEl: ".swiper-button-prev.swiper-button-white",
    // },
    loop: true,
    centeredSlides: true, //アクティブなスライドを中央に表示
    effect: "slide",
    // spaceBetween: 120,
  });

  //   useEffect(() => {
  //     const opusData = props.opusData;
  //     console.log(opusData);
  //     const Images = opusData.images;
  //     console.log(Images);
  //     setOpusImages(Images);
  //     // eslint-disable-next-line
  //   }, [setOpusImages]);

  return (
    <section>
      <Swiper {...params}>
        {React.Children.toArray(
          //   opusImages.length > 0 &&
          opusData.map((opus) => (
            <div className="slider-img">
              <div className="flex-column--justcenter">
                <img key={opus.id} src={opus.path} alt="作品画像" className="fit-cover slide-img-size" />
              </div>
              <div className="spacer-box--s"></div>
              <SliderMenu key={opus.id} name={opus.path} price={opus.id} />
            </div>
          ))
        )}
      </Swiper>
    </section>
  );
};

export default SelectedOpusSlider;
